export const nspSky = {
  50: '#92E0F7',
  100: '#7DDCF8',
  200: '#52D3FA',
  300: '#25CDFF',
  400: '#06C2FB',
  500: '#07A8D9',
  600: '#0691BB',
  700: '#057A9D',
  800: '#046380',
  900: '#034C62',
  950: '#024053',
};

export const nspOcean = {
  50: '#29C0EE',
  100: '#13BDEF',
  200: '#07A4D2',
  300: '#0288B0',
  400: '#027DA2',
  500: '#006B8B',
  600: '#005A75',
  700: '#144A5E',
  800: '#0E3644',
  900: '#09222B',
  950: '#06181E',
};

export const nspSlate = {
  0: '#FFFFFF',
  50: '#A0B4C3',
  100: '#607B8F',
  200: '#496D88',
  300: '#354F64',
  400: '#31495C',
  500: '#2E4456',
  600: '#273A49',
  700: '#253745',
  800: '#162029',
  900: '#0E151A',
  950: '#000000',
};

export const nspMint = {
  50: '#A0E1C3',
  100: '#8EDEB9',
  200: '#6ADAA5',
  300: '#43D792',
  400: '#24CF7F',
  500: '#1FB46F',
  600: '#1A9A5F',
  700: '#16804F',
  800: '#11663F',
  900: '#0D4C2F',
  950: '#0B3F27',
};

export const nspSolar = {
  50: '#FAF3D4',
  100: '#FAEEC1',
  200: '#F9E698',
  300: '#FBDE6E',
  400: '#FFD942',
  500: '#FFD223',
  600: '#FECC04',
  700: '#E5B700',
  800: '#C69E00',
  900: '#A78600',
  950: '#987900',
};

export const nspAmber = {
  50: '#F6C7B0',
  100: '#F5BA9C',
  200: '#F59F73',
  300: '#F78348',
  400: '#FC671C',
  500: '#F65403',
  600: '#D74A02',
  700: '#B93F02',
  800: '#9B3502',
  900: '#7D2B01',
  950: '#6E2501',
};

export const nspCrimson = {
  50: '#E98B94',
  100: '#E87883',
  200: '#E7505F',
  300: '#E8263A',
  400: '#D61024',
  500: '#B90D1F',
  600: '#9D0B1A',
  700: '#800915',
  800: '#640710',
  900: '#47050C',
  950: '#390409',
};

export const nspMist = {
  25: '#f8fafc',
  50: '#f1f5f9',
  100: '#eeeeee',
  150: '#eaeaea',
  200: '#e2e8f0',
  300: '#cbd5e1',
  400: '#94a3b8',
  500: '#64748b',
  600: '#475569',
  700: '#334155',
  800: '#1e293b',
  900: '#0f172a',
  950: '#020617',
};
